var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { ThemeBreakpoints } from "../theme/_Types";
/**
 *
 */
export var breakpointBindingInit = function () { return ({
    breakpointAtXS: false,
    breakpointAtSM: false,
    breakpointAtMD: false,
    breakpointAtLG: false,
    breakpointAtXL: false,
    width: 0,
    height: 0,
}); };
/**
 *
 */
export var BreakpointContext = React.createContext(breakpointBindingInit());
/**
 *
 */
var BreakpointProvider = /** @class */ (function (_super) {
    __extends(BreakpointProvider, _super);
    /**
     *
     * @param props
     * @param ctx
     */
    function BreakpointProvider(props, ctx) {
        var _this = _super.call(this, props, ctx) || this;
        _this.state = _this.getDimensions();
        return _this;
    }
    /**
     *
     */
    BreakpointProvider.prototype.render = function () {
        return (React.createElement(BreakpointContext.Provider, { value: {
                breakpointAtXS: this.state.breakpointAtXS,
                breakpointAtSM: this.state.breakpointAtSM,
                breakpointAtMD: this.state.breakpointAtMD,
                breakpointAtLG: this.state.breakpointAtLG,
                breakpointAtXL: this.state.breakpointAtXL,
                width: this.state.width,
                height: this.state.height,
            } }, this.props.children));
    };
    /**
     *
     */
    BreakpointProvider.prototype.componentDidMount = function () {
        window.addEventListener("resize", this.updateDimensions.bind(this));
    };
    /**
     *
     */
    BreakpointProvider.prototype.componentWillUnmount = function () {
        window.removeEventListener("resize", this.updateDimensions.bind(this));
    };
    /**
     *
     */
    BreakpointProvider.prototype.getDimensions = function () {
        var w = window;
        var d = document;
        var documentElement = d.documentElement;
        var body = d.getElementsByTagName("body")[0];
        var width = w.innerWidth
            || (!documentElement ? undefined : documentElement.clientWidth)
            || body.clientWidth;
        var height = w.innerHeight
            || (!documentElement ? undefined : documentElement.clientHeight)
            || body.clientHeight;
        var breakpointAtXS = (width >= ThemeBreakpoints.XS);
        var breakpointAtSM = (width >= ThemeBreakpoints.SM);
        var breakpointAtMD = (width >= ThemeBreakpoints.MD);
        var breakpointAtLG = (width >= ThemeBreakpoints.LG);
        var breakpointAtXL = (width >= ThemeBreakpoints.XL);
        return { breakpointAtXS: breakpointAtXS, breakpointAtSM: breakpointAtSM, breakpointAtMD: breakpointAtMD, breakpointAtLG: breakpointAtLG, breakpointAtXL: breakpointAtXL, width: width, height: height };
    };
    /**
     *
     */
    BreakpointProvider.prototype.updateDimensions = function () {
        this.setState(this.getDimensions());
    };
    return BreakpointProvider;
}(React.Component));
export { BreakpointProvider };
/**
 *
 */
export var BreakpointConsumer = BreakpointContext.Consumer;
